import { render, staticRenderFns } from "./Titlelabel.vue?vue&type=template&id=45d25deb&scoped=true"
import script from "./Titlelabel.vue?vue&type=script&lang=js"
export * from "./Titlelabel.vue?vue&type=script&lang=js"
import style0 from "./Titlelabel.vue?vue&type=style&index=0&id=45d25deb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d25deb",
  null
  
)

export default component.exports